function StickyBtn(){};
StickyBtn.prototype.init = function(){
  let stickyBtn = document.querySelector(".sticky-add-to-cart");
  let productAddToCartBtn = document.querySelector(".product--info .product-form");
  let quantityInput = document.querySelector(".sticky-quantity input[type='number']");
  let quantityPlus = document.querySelector(".sticky-plus");
  let quantityMinus = document.querySelector(".sticky-minus");
  let stickyForm = document.querySelector(".sticky-cart-form");
  ////////////////Quantity button logic
  stickyForm.addEventListener("submit",(e)=>{
    e.preventDefault();
  })
  quantityInput.addEventListener("input",(e)=>{
    e.preventDefault();
  })
  quantityPlus.addEventListener('click',(e)=>{
    e.preventDefault();
    quantityInput.value = Number(quantityInput.value) + 1;
  })
  quantityMinus.addEventListener('click',(e)=>{
    e.preventDefault();
    quantityInput.value = quantityInput.value > 1 ?  Number(quantityInput.value) - 1 : 1;
  })
  ///////////////Display or hide sticky bar
  const elementToObserve = productAddToCartBtn;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
         stickyBtn.classList.remove("visible");
        // console.log("visible")
      } else {
        // StickyBtn.prototype.setVariant();
        stickyBtn.classList.add("visible");
      }
    });
  }, { threshold: 0.2 });
  observer.observe(elementToObserve);
  this.variantSelector();
}
StickyBtn.prototype.variantSelector = function(){
  let variantSelectors = Array.from(document.querySelectorAll(".sticky-variants select"));
  let selectedOpts = [];
  variantSelectors.forEach((el,ind)=>{
    el.addEventListener("change",()=>{
      selectedOpts = [];
      let form = el.closest("form");
      let variantDataString = form.querySelector("script[type='application/ld+json']").innerHTML;
      let variantData = JSON.parse(variantDataString);
      variantSelectors.forEach((el,ind)=>{
        selectedOpts.push(el.value);
      })
      let selectedVaraintData = variantData.variants.find((el) => el.options.length == selectedOpts.length && el.options.every(el => selectedOpts.indexOf(el) != -1));
      el.closest("form").querySelector("input[name='id']").value = selectedVaraintData.id;
      selectedVaraintData.available ? el.closest("form").querySelector("input[type='submit']").removeAttribute("disabled") : el.closest("form").querySelector("input[type='submit']").setAttribute("disabled","true");
    })
  })
}
new StickyBtn().init();

// StickyBtn.prototype.setVariant = function(){
//       var selectedTrue = document.querySelector(".variants-option option[selected='true']").getAttribute("data-value")
//       var el = document.querySelectorAll(".sticky-variants")[0];
//       let form = el.closest("form");
//       let variantDataString = form.querySelector("script[type='application/ld+json']").innerHTML;
//       let variantData = JSON.parse(variantDataString);
//       let selectedVaraintData = variantData.variants.find((el) => el.option1 == selectedTrue );
//       console.log(selectedVaraintData)
//       el.closest("form").querySelector("input[name='id']").value = selectedVaraintData.id;
//       selectedVaraintData.available ? el.closest("form").querySelector("input[type='submit']").removeAttribute("disabled") : el.closest("form").querySelector("input[type='submit']").setAttribute("disabled","true");
// }
var selectList = document.querySelector(".sticky-variant-block .variants-option select")
  
selectList.addEventListener("change", function() {
  const selectedOption = selectList.options[selectList.selectedIndex];
  var stickySize = selectedOption.getAttribute('data-value')
  document.querySelector(`input[value='${stickySize}']`).click();
})